import axios from "axios";
import { axiosErrorHandler } from "../../utility/action-helper";
import { formatTelegramLog } from "../../utility/formatter-helper";

const initialState = {
  botInfoStatus: "",
  botInfo: {},
  overallBotPerformance: {},
  botInfoError: "",
  signalInfoStatus: "",
  signalInfoError: "",
  signalInfo: {},
  taskInfoStatus: "",
  taskInfoError: "",
  taskInfo: {},
  analyticsinfoStatus: "",
  analyticsinfoError: "",
  analyticsinfo: {},
  communityBots: {},
};

export const dashboardReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case "get-bot-info-request/dashboard":
      return {
        ...state,
        botInfoStatus: "loading",
        botInfoError: "",
      };
    case "get-bot-info-success/dashboard":
      return {
        ...state,
        botInfoStatus: "success",
        botInfo: payload?.bot_info,
        overallBotPerformance: payload?.overall_bot_performance,
        communityBots: payload?.community_bots || state.communityBots,
      };
    case "get-bot-info-error/dashboard":
      return {
        ...state,
        botInfoStatus: "error",
      };

    case "get-task-info-request/dashboard":
      return {
        ...state,
        taskInfoStatus: "loading",
        taskInfoError: "",
      };
    case "get-task-info-success/dashboard":
      return {
        ...state,
        taskInfo: payload,
        taskInfoStatus: "success",
      };
    case "get-task-info-error/dashboard":
      return {
        ...state,
        taskInfoStatus: "error",
        taskInfoError: payload,
      };

    case "get-signals-info-request/dashboard":
      return {
        ...state,
        signalInfoStatus: "loading",
      };
    case "get-signals-info-success/dashboard":
      return {
        ...state,
        signalInfoStatus: "success",
        signalInfo: payload?.latest_signals,
      };
    case "get-signals-info-error/dashboard":
      return {
        ...state,
        signalInfoStatus: "error",
        signalInfoError: payload,
      };

    case "get-analytics-info-request/dashboard":
      return {
        ...state,
        analyticsinfoStatus: "loading",
      };
    case "get-analytics-info-success/dashboard":
      return {
        ...state,
        analyticsinfoStatus: "success",
        analyticsinfo: payload?.dashboard_analytics,
      };
    case "get-analytics-info-error/dashboard":
      return {
        ...state,
        analyticsinfoStatus: "error",
        analyticsinfoError: payload,
      };

    default:
      return state;
  }
};

export const getBotInfo =
  (
    user,
    email,
    include_community = "true",
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: "get-bot-info-request/dashboard" });

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";
    const data = {
      user,
      email,
      platform_mode: "dashboard_bot_info",
      include_community,
    };

    await axios
      .post(url, data)
      .then((response) => {
        // console.log(response);
        dispatch({
          type: "get-bot-info-success/dashboard",
          payload: response?.data,
        });
      })
      .catch((error) => {
        console.log(error);
        axiosErrorHandler(
          error,
          retryCount,
          dispatch,
          () => getBotInfo(user, email, include_community, retryCount + 1),
          "get-bot-info-error/dashboard",
          user,
          email,
          formatTelegramLog("dashboard_bot_info", data, url),
          0,
          currentPath,
        );
      });
  };

export const getSignalsInfo =
  (user, email, retryCount = 0, currentPath = window?.location?.href) =>
  async (dispatch) => {
    dispatch({ type: "get-signals-info-request/dashboard" });

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";
    const data = {
      user,
      email,
      platform_mode: "dashboard_signals",
    };

    await axios
      .post(url, data)
      .then((response) => {
        // console.log(response);
        dispatch({
          type: "get-signals-info-success/dashboard",
          payload: response?.data,
        });
      })
      .catch((error) => {
        console.log(error);
        axiosErrorHandler(
          error,
          retryCount,
          dispatch,
          () => getSignalsInfo(user, email, retryCount + 1),
          "get-signals-info-error/dashboard",
          user,
          email,
          formatTelegramLog("dashboard_signals", data, url),
          0,
          currentPath,
        );
      });
  };

export const getTaskInfo =
  (user, email, retryCount = 0, currentPath = window?.location?.href) =>
  async (dispatch) => {
    dispatch({ type: "get-task-info-request/dashboard" });

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";
    const data = {
      platform_mode: "dashboard_tasks",
      user,
      email,
    };

    await axios
      .post(url, data)
      .then((response) => {
        // console.log(response);
        dispatch({
          type: "get-task-info-success/dashboard",
          payload: response?.data,
        });
      })
      .catch((error) => {
        console.log(error);
        axiosErrorHandler(
          error,
          retryCount,
          dispatch,
          () => getTaskInfo(user, email, retryCount + 1),
          "get-task-info-error/dashboard",
          user,
          email,
          formatTelegramLog("dashboard_tasks", data, url),
          0,
          currentPath,
        );
      });
  };

export const getAnalyticsInfo =
  (user, email, retryCount = 0, currentPath = window?.location?.href) =>
  async (dispatch) => {
    dispatch({ type: "get-analytics-info-request/dashboard" });

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";
    const data = {
      platform_mode: "dashboard_analytics",
      user,
      email,
    };

    await axios
      .post(url, data)
      .then((response) => {
        // console.log(response);
        dispatch({
          type: "get-analytics-info-success/dashboard",
          payload: response?.data,
        });
      })
      .catch((error) => {
        console.log(error);
        axiosErrorHandler(
          error,
          retryCount,
          dispatch,
          () => getAnalyticsInfo(user, email, retryCount + 1),
          "get-analytics-info-error/dashboard",
          user,
          email,
          formatTelegramLog("dashboard_analytics", data, url),
          0,
          currentPath,
        );
      });
  };
